import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, Container } from '@mui/material';
import { Home, Error } from '@mui/icons-material';

const NotFoundPage: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        textAlign="center"
        p={3}
      >
        <Error sx={{ fontSize: 120, color: 'text.secondary', mb: 2 }} />
        
        <Typography variant="h2" component="h1" gutterBottom>
          404
        </Typography>
        
        <Typography variant="h5" component="h2" gutterBottom color="text.secondary">
          Página não encontrada
        </Typography>
        
        <Typography variant="body1" color="text.secondary" mb={4} maxWidth="sm">
          Desculpe, a página que você está procurando não existe ou foi movida.
        </Typography>
        
        <Button
          component={RouterLink}
          to="/dashboard"
          variant="contained"
          startIcon={<Home />}
          size="large"
        >
          Voltar ao Dashboard
        </Button>
      </Box>
    </Container>
  );
};

export default NotFoundPage; 